import React from 'react';
import { CTAButton } from './CTAButton';
import { useInView } from '../hooks/useInView';
import { ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function FinalCTA() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section className="bg-white py-12 md:py-20 px-4 border-t border-gray-100" data-id="element-35">
      <div className="max-w-2xl mx-auto text-center" data-id="element-36">
        <div ref={ref} className={`fade-in ${isVisible ? 'is-visible' : ''}`} data-id="element-37">
          <h2 className="font-heading text-xl md:text-3xl text-headline font-extrabold mb-4 md:mb-6 tracking-tight" data-id="element-38">
            Non rimandare. Inizia oggi.
          </h2>
          <p className="text-body text-sm md:text-base font-light mb-6 md:mb-8 leading-relaxed max-w-lg mx-auto" data-id="element-39">
            6 Manuali Tecnici + 5 Bonus Esclusivi. Tutto a soli €67 invece di
            €497. Garanzia 14 giorni soddisfatti o rimborsati.
          </p>
          <CTAButton className="text-base md:text-xl py-4 md:py-5 px-8 md:px-14" data-id="element-40">
            SÌ, VOGLIO ACCEDERE ORA (€67)
          </CTAButton>

          <div className="mt-8 flex flex-col items-center justify-center gap-3" data-id="element-41">
            <div className="flex items-center gap-4 text-body/50" data-id="element-42">
              <div className="flex items-center gap-1.5" data-id="element-43">
                <Lock className="w-4 h-4" data-id="element-44" />
                <span className="text-xs font-medium" data-id="element-45">Safe Checkout</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-46">
                <CreditCard className="w-4 h-4" data-id="element-47" />
                <span className="text-xs font-medium" data-id="element-48">Visa / Mastercard</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-49">
                <ShieldCheck className="w-4 h-4" data-id="element-50" />
                <span className="text-xs font-medium" data-id="element-51">PayPal</span>
              </div>
            </div>
            <p className="text-xs text-body/40 font-medium" data-id="element-52">
              Pagamento sicuro e protetto al 100%
            </p>
          </div>
        </div>
      </div>
    </section>;
}